/**
 * 退房
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import RoomGuestInfo from '@/components/Reservation/RoomGuestInfo';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkOut';

const stateSelector = (state: ReducerState, globalStore) => {
  const { roomGuestList } = state;
  const { memberLevelMap } = globalStore.guest;
  return { roomGuestList, memberLevelMap };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  return (
    <RoomGuestInfo
      title={intl.get('drawer_checkout_guest_block_title')}
      dataSource={props.roomGuestList}
      memberLevelMap={props.memberLevelMap}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
